<template>
    <PicturePage picName="1.qijs"/>
</template>

<script>

import PicturePage from "@/component/PicturePage.vue";
export default {
  data() {
    return {

    };
  },

  methods: {

  },

  components: {PicturePage}
};
</script>

<style lang="scss">

</style>
